/**
 * 使用常量替代 mutation 事件类型
 */
// 根据用户名登录
export const LOGIN_BY_USERNAME = 'LOGIN_BY_USERNAME';
export const LOGIN_TOKEN_OLD = 'LOGIN_TOKEN_OLD';
// 获取权限菜单分类
export const GET_MENU_MAP_SORT = 'GET_MENU_MAP_SORT';
// 当前分类菜单索引
export const SET_MENU_CATEGORY_INDEX = 'SET_MENU_CATEGORY_INDEX';
// 获取到权限菜单
export const GET_MENU_MAP = 'GET_ROUTES_MAP';
// 退出登录
export const LOGOUT = 'LOGOUT';
// 刷新token
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
// 获取用户基本信息
export const SET_USER_INFO = 'SET_USER_INFO';
// 当前域名下的信息
export const SET_APP_INFO = 'SET_APP_INFO';
